'use strict';
if (window.Groupon == null) {
  window.Groupon = {};
}

if (Groupon.Performance == null) {
  Groupon.Performance = {};
}

Groupon.Performance.pageReady = function() {
  if (typeof BOOMR.page_ready === 'function') {
    return BOOMR.page_ready();
  } else {
    return BOOMR.t_done = new Date().getTime();
  }
};

